var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"compensation"}),_c('navbar',{on:{"set-sticky":_vm.compensateNav}}),_c('router-view',{attrs:{"id":"view"}}),_c('Footer'),_c('up-button')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }